function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Card, Divider, Checkbox, Result, Image } from "antd";
import { QuestionCircleFill, SaveFill } from 'react-bootstrap-icons';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var Modules = function Modules() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLabActive = _useState2[0],
    setIsLabActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMcheckActive = _useState4[0],
    setIsMcheckActive = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isImActive = _useState6[0],
    setIsImActive = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCustomerActive = _useState8[0],
    setIsCustomerActive = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isAccountingActive = _useState0[0],
    setIsAccountingActive = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isOphtaActive = _useState10[0],
    setIsOphtaActive = _useState10[1];
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        className: "d-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          children: /*#__PURE__*/_jsx(Result, {
            icon: /*#__PURE__*/_jsx(Image, {
              preview: false,
              width: "70%",
              src: "/drawables/play.gif"
            }),
            title: "Votre compte \xE0 \xE9t\xE9 cr\xE9\xE9 !",
            subTitle: "Vous \xEAtes pr\xEAt \xE0 commencer, choisissez une des actions pour g\xE9rer vos donn\xE9es m\xE9dicales d\xE8s maintenant.",
            extra: [/*#__PURE__*/_jsx(Button, {
              size: "large",
              href: "/#/home/departments",
              type: "primary",
              children: /*#__PURE__*/_jsx("b", {
                children: "Configurez les tarifs"
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              href: "/#/home/cashier",
              type: "defautl",
              children: /*#__PURE__*/_jsx("b", {
                children: "Cr\xE9er un dossier m\xE9dical"
              })
            })]
          })
        })
      })
    })
  });
};
export default Modules;